/**
 * Theme expects global `Swiper` in some components (e.g. `m-slideshow`).
 * Minimog bundles Swiper under `window.MinimogLibs.Swiper`.
 * This shim provides `window.Swiper` without modifying the bundled theme JS.
 */
;(function () {
  function attach() {
    if (window.Swiper) return true
    if (window.MinimogLibs && window.MinimogLibs.Swiper) {
      window.Swiper = window.MinimogLibs.Swiper
      return true
    }
    return false
  }

  // Try immediately (in case libs are already present), then retry once DOM is parsed.
  if (attach()) return

  document.addEventListener(
    'DOMContentLoaded',
    function () {
      attach()
    },
    { once: true }
  )
})()

